export const ON_LOAD_CAMPAIGNS = "ON_LOAD_CAMPAIGNS";
export const ON_LOAD_CAMPAIGN = "ON_LOAD_CAMPAIGN";

export const OPEN_CAMPAIGN_ADD_POPUP = "OPEN_CAMPAIGN_ADD_POPUP";
export const CLOSE_CAMPAIGN_ADD_POPUP = "CLOSE_CAMPAIGN_ADD_POPUP";

export const OPEN_STAT = "OPEN_STAT";
export const CLOSE_STAT = "CLOSE_STAT";
export const ON_LOAD_STAT = "ON_LOAD_STAT";

export const OPEN_SETTINGS = "OPEN_SETTINGS";
export const CLOSE_SETTINGS = "CLOSE_SETTINGS";

export const CHANGE_ADD_FORM_FIELD = "CHANGE_ADD_FORM_FIELD";

export const SET_EDIT_FORM_FIELD = "SET_EDIT_FORM_FIELD";

export const ON_CREATE_CAMPAIGN_FAILD = "ON_CREATE_CAMPAIGN_FAILD";
export const ON_CREATE_CAMPAIGN_SUCCESS = "ON_CREATE_CAMPAIGN_SUCCESS";

export const ADD_FORM_SET_ENABLED = "ADD_FORM_SET_ENABLED";

export const ON_SAVE_CAMPAIGN_FAILD = "ON_SAVE_CAMPAIGN_FAILD";
export const ON_SAVE_CAMPAIGN_SUCCESS = "ON_SAVE_CAMPAIGN_SUCCESS";

export const SET_CAMPAIGN_TABLE_SORT = "SET_CAMPAIGN_TABLE_SORT";

export const SET_CAMPAIGN_STAT_SORT = "SET_CAMPAIGN_STAT_SORT";

export const OPEN_ADW_CAMPAIGN_POPUP = "OPEN_ADW_CAMPAIGN_POPUP";

export const ON_LOAD_ADW_CAMPAIGN = "ON_LOAD_ADW_CAMPAIGN";

export const SET_ADW_CAMPAIGN_FIELD = "SET_ADW_CAMPAIGN_FIELD";

export const ON_SAVE_ADW_CAMPAIGN_FAILD = "ON_SAVE_ADW_CAMPAIGN_FAILD";
export const ON_SAVE_ADW_CAMPAIGN_SUCCESS = "ON_SAVE_ADW_CAMPAIGN_SUCCESS";

export const SET_CAMPAIGN_LIST_DATE_RANGE = "SET_CAMPAIGN_LIST_DATE_RANGE";
export const ON_SET_CAMPAIGN_STATUS_SUCCESS = "ON_SET_CAMPAIGN_STATUS_SUCCESS";

export const status = {
  STATUS_STOP: "stop",
  STATUS_START: "start",
  STATUS_MODERATE: "moderation",
  STATUS_SUSPEND: "pause",
  STATUS_ARCHIVE: "archive",
  STATUS_REJECTED: "reject"
};

export const device = {
  PC: "PC",
  MOBILE: "MOBILE",
  TABLET: "TABLET",

  MOBILE_IOS: "MOBILE_IOS",
  MOBILE_ANDROID: "MOBILE_ANDROID",
  MOBILE_WINDOWS: "MOBILE_WINDOWS",
  MOBILE_SYMBIAN: "MOBILE_SYMBIAN",

  TABLET_IOS: "TABLET_IOS",
  TABLET_ANDROID: "TABLET_ANDROID",
  TABLET_WINDOWS: "TABLET_WINDOWS"
};

export const deviceTree = [
  {
    key: device.PC,
    title: "Стационарные устройства"
  },
  {
    key: device.MOBILE,
    title: "Мобильные устройства",
    folder: true,
    children: [
      { key: device.MOBILE_IOS, title: "IOS" },
      { key: device.MOBILE_ANDROID, title: "Android" },
      { key: device.MOBILE_WINDOWS, title: "Window Mobile" },
      { key: device.MOBILE_SYMBIAN, title: "Symbian" }
    ]
  },
  {
    key: device.TABLET,
    title: "Планшеты",
    folder: true,
    children: [
      { key: device.TABLET_WINDOWS, title: "Windows" },
      { key: device.TABLET_ANDROID, title: "Android" },
      { key: device.TABLET_IOS, title: "IOS" }
    ]
  }
];

export const tagScheme = {
  DISABLE: 0,
  DEFAULT: 1,
  CUSTOM: 2
};

export const tagSchemeLookup = {
  1: "Стандартная",
  2: "Индивидуальная",
  0: "Отключена"
};

export const filter = {
  DISABLE: "disable",
  CONDITION_ALLOW: "allow",
  CONDITION_DENY: "deny"
};
